export default {"src":"/_next/static/media/telegram.ac8816f9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};